import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogOverlay,
} from "@chakra-ui/react";
import { useAlertContext } from "../context/alertContext";
import { useRef } from "react";
/**
 * This is a global component that uses context to display a global alert message.
 */
function Alert() {
  const { isOpen, onClose } = useAlertContext();
  const cancelRef = useRef();

  return (
    <AlertDialog
      isOpen={isOpen}
      leastDestructiveRef={cancelRef}
      onClose={onClose}
    >
      <AlertDialogOverlay>
        <AlertDialogContent py={4} backgroundColor={'#81C784'}>
          <AlertDialogHeader fontSize="lg" fontWeight="bold">
            Thanks for your message, I will get back to you shortly!
          </AlertDialogHeader>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );
}

export default Alert;
